import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers} from '../../../../../lib/helpers';
import {EditContentStore} from '../../../x7/content-parts/EditContentStore';
import {InlineOpenEndedQuestionModel} from '../models';
import {OpenEndedQuestionEditStore} from './OpenEndedQuestionEditStore';
import {openEndedQuestionEditStoreRenderer} from './openEndedQuestionEditStoreRenderer';

@observer
export class OpenEndedQuestionInlineEdit extends React.Component<{ store: EditContentStore }> {
  readonly store: OpenEndedQuestionEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: EditContentStore; }>) {
    super(props);
    this.store = new OpenEndedQuestionEditStore();

    const value = props.store.content.Contents;
    const model = JSON.parse(value) as InlineOpenEndedQuestionModel;
    this.store.setModel(model);

    this.setup();
  }

  setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        () => this.props.store.setValid(this.store.valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Content,
        () => this.props.store.setContents(this.store.x9Content),
        {fireImmediately: true}
      ));
  }

  render() {
    return Array.from(openEndedQuestionEditStoreRenderer(this.store));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
